export default __webpack_public_path__ + "static/media/gallery15.8561d28d.jpg";